import { getPathname } from './get-pathname';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getPathname } from './get-pathname';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { modelIdValidator } from './model-id-validator';

/**
 * Compares two URLs by their pathnames
 * @param a URL string
 * @param b URL string
 * @returns true if the pathnames are the same, false otherwise
 */
export const isSamePathname = (a: string, b: string): boolean => {
	try {
		return getPathname(a) === getPathname(b);
	} catch {
		return false;
	}
};
